fragment JobStatusFragment on JobStatus {
    id
    type
    updated_at
    created_at
    started_at
    finished_at
    attempts
    job_id
    queue
    status
    progress_max
    progress_now
    input
    output

    queued
    progress_percentage
    is_ended
    is_executing
    is_failed
    is_finished
    is_queued
    is_retrying
}